module.exports = __webpack_public_path__ + "static/media/pandaria-3.efefe465.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/pandaria-3.jpg
// module id = 105
// module chunks = 0